import { useEffect } from "react";

export default function PublicSite() {
  useEffect(() => {
    if (!document.getElementById("riviera-shim")) {
      const shim = document.createElement("script");
      shim.src = "/riviera/shim.js";
      shim.id = "riviera-shim";
      shim.onload = () => {
        const eng = document.createElement("script");
        eng.src = "/riviera/engine.js";
        eng.id = "riviera-engine";
        document.body.appendChild(eng);
      };
      document.body.appendChild(shim);
    } else {
      window.dispatchEvent(new HashChangeEvent("hashchange"));
    }
    return () => {
      const app = document.getElementById("app");
      if (app) app.innerHTML = "";
    };
  }, []);
  return <div id="app" data-testid="public-site" />;
}
